import { Endpoint } from '@/constants';
import { useShipping } from '@/contexts/shippingContext';
import { useSendOrder } from '@/hooks/useSendOrder';

export const useNoBalance = () => {
  const { isPending, sendOrder } = useSendOrder(Endpoint.SendNoBalance);
  const { orderPayload } = useShipping();

  const createOrder = () => {
    console.info('useNoBalance: createOrder called');
    sendOrder(orderPayload);
  };

  return { createNoBalanceOrder: createOrder, isPending };
};
